import { DataProduct } from 'v2/models';
import datasetIcon from 'v2/icons/datasetAvatar.svg';

export function getDatasetAvatarURL(dataset: DataProduct) {
  return dataset.data_vendor?.avatar_url || datasetIcon;
}
